"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadMembershipEmails = exports.FetchMembershipEmails = exports.FetchMembershipEmailsActionTypes = exports.MembershipEmailsActionTypes = void 0;

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-sdk/utils/actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var MembershipEmailsActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_MEMBERSHIP_EMAILS: null,
  LOAD_MEMBERSHIP_EMAILS: null
}, _UrlPathParams.CONTENT_MEMBERSHIP);
exports.MembershipEmailsActionTypes = MembershipEmailsActionTypes;
var FetchMembershipEmailsActionTypes = (0, _actions.createRequestTypes)(MembershipEmailsActionTypes.FETCH_MEMBERSHIP_EMAILS);
exports.FetchMembershipEmailsActionTypes = FetchMembershipEmailsActionTypes;
var FetchMembershipEmails = (0, _actions.createRequestActions)(FetchMembershipEmailsActionTypes);
exports.FetchMembershipEmails = FetchMembershipEmails;
var loadMembershipEmails = (0, _fluxActions.createAction)(MembershipEmailsActionTypes.LOAD_MEMBERSHIP_EMAILS);
exports.loadMembershipEmails = loadMembershipEmails;